<h4 class="code-disponibili" *ngIf="code.length > 0">Code disponibili</h4>
<div *ngFor="let coda of code" class="elenco-code">
  <app-coda-esercizio [idCoda]="coda.id" [attiva]="nonAncoraPrenotata(coda.id)" 
      (prenota)="notifica(coda);"></app-coda-esercizio>
</div>
